<app-gse-create-submission-dialog
  [creditStructure]="data"
  [calculationStructure]="calculationStructure$ | async"
  [currentPortfolio]="currentPortfolio$ | async"
  (close)="onClose()"
></app-gse-create-submission-dialog>
